import { SoftwareRovoStartPage } from "src/pages/software/rovo/start/software-rovo-start-page";

import { init } from "../../../init-streaming";
init(SoftwareRovoStartPage);
